<template>
  <TransactionFormAccount v-bind="{ ...$attrs, instance }" :entry-index="1" />
</template>

<script setup lang="ts">
import { TransactionClass } from '..'

import TransactionFormAccount from './TransactionFormAccount.vue'

type Props = {
  instance: TransactionClass
}

defineProps<Props>()
</script>
